export const MESSAGES = {
  genericError:
    'We have encountered an unexpected error. Our team has been notified.',
  systemError: 'System Error',
  exceedsBalance:
    'The amount requested exceeds the available balance in your account',
  expiredSession: 'Your session has expired. Please login again',
  invalidFormatLink: 'Invalid format link',
  duplicateNickname: 'This nickname already exists, please use another',
};
